import { render } from "./PeriodList.vue?vue&type=template&id=27e26daf&scoped=true&ts=true"
import script from "./PeriodList.vue?vue&type=script&lang=ts"
export * from "./PeriodList.vue?vue&type=script&lang=ts"

import "./PeriodList.vue?vue&type=style&index=0&id=27e26daf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e26daf"]])

export default __exports__